<div class="flex flex-col w-full h-full">
  <div class="w-full border-b-2 p-3">
    <img [src]="logoPath" [alt]="pageTitle" width="232" height="28" />
  </div>
  <div class="flex flex-col justify-center items-center w-full h-full text-center px-3">
    <div class="flex flex-col items-start max-w-4/5 sm:max-w-[420px]">
      <p class="text-left text-4xl pb-6">{{ 'ERROR_PAGE.TITLE' | transloco }}</p>

      <aup-notification-bar
        title="{{ 'ERROR_PAGE.TITLE' | transloco }}"
        message="{{ 'ERROR_PAGE.MESSAGE' | transloco }}"
        [type]="EAppNotificationType.ERROR"
        [dismissable]="false"
        class="w-full"
      ></aup-notification-bar>

      <div class="w-full border-t-2 mt-6 pt-3">
        <a mat-button color="primary" (click)="authService.logout()">
          <mat-icon svgIcon="arrow-left"></mat-icon>
          <span>{{ 'ERROR_PAGE.BACK_TO_LOGIN' | transloco }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
